<template>
  <div class="pa-6">
    <Loader :messageSelector="messageSelector" :overlay="overlay" />
    <v-form ref="form" v-model="valid" :disabled="readonly">

      <fieldset>    
        <legend class="text-h6 text-sm-h5">
          Déclarations Obligatoires
        </legend>
        <RessourceInfoBulle code="APRP-DO-1" />
        <RessourceInfoBulle code="APRP-DO-2" />

        <v-checkbox v-model="attestationVeracite.engagementACompleterLesFormations"
                    :rules="rules.checkboxChecked"
                    class="li cssRequired"
                    color="primary"
                    hide-details
                    required>
          <template v-slot:label>
            <div class="ml-5">
              Je m'engage à compléter les formations ci-haut mentionnées avant la délivrance de mon permis advenant
              qu'une délivrance du permis spécial me soit octroyée.
            </div>
          </template>
        </v-checkbox>

      </fieldset>

      <fieldset>    
        <legend class="text-h6 text-sm-h5">
          Détails relatifs au paiement
        </legend>
        <RessourceInfoBulle code="APRP-DO-3" />
        <RessourceInfoBulle code="APRP-DO-4" />
        <RessourceInfoBulle code="APRP-DO-5" />
        <RessourceInfoBulle code="APRP-DO-6" />
      </fieldset>

      <fieldset>
        <legend class="text-h6 text-sm-h5">Attestation et serment d'office</legend>
        <v-checkbox v-model="attestationVeracite.identiteEtRenseignements"
                    :rules="rules.checkboxChecked"
                    class="li cssRequired"
                    color="primary"
                    hide-details
                    required>
          <template v-slot:label>
            <div class="ml-5">
              Je certifie que je suis bien <strong>{{ nomDuDemandant }}</strong> ou son représentant légal et que tous
              les renseignements indiqués sur ce formulaire électronique sont exacts et complets.
            </div>
          </template>
        </v-checkbox>
      </fieldset>
    </v-form>

    <!-- Buttons -->
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid" color="secondary" @click="saveAndContinueLater()"> Enregistrer et terminer plus tard </v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Loader from "../Loader"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin"

export default {
  mixins: [
    NavigationPageFormulaireMixin,
    PageReadonlyFormulaireAdmissionMixin,
  ],
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  components: {
    Loader: Loader,
  },
  data() {
    return {
      messageSelector: "",
      overlay: false,
      valid: false,
      rules: {
        checkboxChecked: [
          (v) => (!!v && v == true) || "Vous devez accepter ces termes",
        ],
      },
    }
  },
  computed: {
    ...mapGetters({
      attestationVeracite: "AttestationVeracites/GET_ATTESTATIONSVERACITES",
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      demandeAdmissionPpId: "DemandeAdmission/GET_CONTACTID",
      demandeAdmission: "DemandeAdmission/GET_DEMANDEADMISSION",
    }),
    nomDuDemandant: function () {
      return this.demandeAdmission.firstName + " " + this.demandeAdmission.lastName
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    ...mapActions({
      getAttestationVeracitesByDemandeAdmissionId: "AttestationVeracites/getAttestationsVeracitesByDemandeAdmissionId",
      getAttestationVeracitesByContactId: "AttestationVeracites/getAttestationsVeracitesByContactId",
      updateAttestationVeracites: "AttestationVeracites/updateAttestationsVeracites",
      createAttestationVeracites: "AttestationVeracites/createAttestationsVeracites",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        if (this.demandeAdmissionId) {
          await this.getAttestationVeracitesByDemandeAdmissionId(this.demandeAdmissionId)
        } else if (this.demandeAdmissionPpId) {
          await this.getAttestationVeracitesByContactId(this.demandeAdmissionPpId)
        }

        this.validateForm(true)
        this.overlay = false
      } catch (exception) {
        console.log("Exception", exception)
      }
    },
    async save() {
      this.validateForm()
      if (this.valid && this.attestationVeracite) {
        this.messageSelector = "Creation"
        this.overlay = true

        if (this.demandeAdmissionId) {
          this.attestationVeracite.demandeAdmission = this.demandeAdmissionId
        }
        if (this.demandeAdmissionPpId) {
          this.attestationVeracite.pp = this.demandeAdmissionPpId
        }

        if (this.attestationVeracite.id) {
          await this.updateAttestationVeracites(this.attestationVeracite)
        } else {
          await this.createAttestationVeracites(this.attestationVeracite)
        }

        this.overlay = false
        this.redirect()
      }
    },
    validateForm(resetValidation = false) {
    this.valid = (this.$refs.form?.validate() || false)
      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
  },
}
</script>